import type { Site } from '@ps/web-core-enums';
import classNames from 'clsx';
import React from 'react';

import { EligibleFeatures, RenderNames } from '@swf/casino';
import type { CasinoTable } from '@swf/core/types/CasinoGame';

import styles from './BetInfo.scss';

interface Props {
  className?: string;
  siteId: Site;
  data: CasinoTable;
  shortText?: boolean;
  setBetFeatureCount(count: number): void;
}

const BetInfo: React.FC<Props> = ({
  className,
  data,
  setBetFeatureCount,
  siteId,
  shortText,
  ...rest
}) => (
  <div className={classNames(styles.container, className)}>
    <EligibleFeatures
      className={classNames(styles.tightDetail)}
      siteId={siteId}
      data={data}
      shortText={shortText}
      setBetFeatureCount={setBetFeatureCount}
      showFields={[
        RenderNames.minBet,
        RenderNames.maxBet,
        data?.properties?.lines ? RenderNames.paylines : RenderNames.returnToPlayer
      ]}
      {...rest}
    />
  </div>
);

export default BetInfo;
